export default "__VITE_ASSET__c3c780e5__"